<template>
  <div class="product__fetch-error">
    {{
      $t(
        'Sorry, an error occurred while searching for the product you requested.'
      )
    }}
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'ProductFetchError',
});
</script>

<style lang="scss" scoped>
.product__fetch-error {
  width: fit-content;
  margin: 0 auto;
  padding: 6.25rem;
  height: fit-content;
  @include desktop-h6;
}
</style>
